import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import './Login.css';

function Login() {
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      await instance.loginPopup(loginRequest);
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>🏋️ FitPass Store</h1>
        <p className="subtitle">AI-Powered Multi-Sport Card Shopping Assistant</p>
        
        <div className="login-content">
          <h2>Witamy w FitPass!</h2>
          <p>Zaloguj się aby uzyskać dostęp do inteligentnego asystenta zakupów kart sportowych.</p>
          
          <button className="login-button" onClick={handleLogin}>
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.5 0C4.701 0 0 4.701 0 10.5S4.701 21 10.5 21 21 16.299 21 10.5 16.299 0 10.5 0z" fill="#F25022"/>
              <path d="M10.5 0v10.5H21C21 4.701 16.299 0 10.5 0z" fill="#7FBA00"/>
              <path d="M10.5 10.5V21c5.799 0 10.5-4.701 10.5-10.5H10.5z" fill="#FFB900"/>
              <path d="M0 10.5h10.5V21C4.701 21 0 16.299 0 10.5z" fill="#00A4EF"/>
            </svg>
            Zaloguj się przez Microsoft
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;